import axios from "@/utils/NewLive.js";
//获取列表
export const getTv = (params) => axios.get("/tv", { params });
//获取单个直播
// export const getELiveListOneSer = (id) => axios.get(`/activity/info/${id}`);
//删除

export const deleteELiveSer = (ids) => axios.delete(`/tv/${ids}`);
// //添加;
export const addTv = (data) => axios.post("/tv", data);

//获取通道
export const getChannel = (params) => axios.get("/passageway", { params });

//获取节目单列表
export const getProgramList = (params) => axios.get("/program", { params });

//提交虚拟直播节目单
export const visual = (ids,params) => axios.post(`/program/visual/${ids}`, params);

//删除节目单

export const deletepro = (ids) => axios.delete(`/program/${ids}`);

//修改/添加节目单
export const updateprogram = (data) => axios.post("/program", data);

//获取电视详情
export const getTvDetail = (id) => axios.get(`/tv/preview/${id}`);
//获取路况详情
export const getroadDetail = (id) => axios.get(`/traffic/preview/${id}`);
//复制节目单
export const copyProgram = (data) =>
  axios.post("/program/copyProgram", null, { params: data });

//复制编单
export const copyVisualProgram = (data) =>
  axios.post("/program/copyVisualProgram", null, { params: data });

//菜单排序
export const menuSorting = (params) => axios.post("/livemenu/sort", params);
//编辑活动菜单
export const editMenu = (params) => axios.post("/livemenu/change", params);
//删除活动菜单
export const removeMenu = (id) => axios.delete(`/livemenu/del?menuId=${id}`);
//获取活动菜单
export const menuList = (id,type) => axios.get(`/livemenu/query?liveId=${id}&findType=${type}`);
//开关菜单
export const addELiveSer = (id) => axios.get(`/livemenu/status?menuId=${id}`);
//开关评论审核
export const addExamine = (id) => axios.get(`/livemenu/examine?menuId=${id}`);
// 获取微信二维码链接
export const getQRcode = () => axios.get("/wx/config");